import { TemplatesScreen } from '@/components/templates/TemplatesScreen';

export function TemplatesPage() {
  return <TemplatesScreen />;
}
